<template>
	<div
		ref="root-div"
		class="d-lg-none w-100 popup-prestation-slider-mobile mb-2 overflow-hidden"
	></div>
</template>

<script>
import MobileSlider from "@/sliders/mobileSlider";
import { mapState } from "vuex";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "SliderMobile",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			data: {},
			slider: null,
		};
	},
	computed: {
		...mapState(["screenType"]),

		srcObjectsArray() {
			const objectsArray = this.prestation.picturesAccomodation;
			objectsArray.forEach((obj) => {
				obj["type"] = "image";
			});
			return objectsArray;
		},
	},
	methods: {
		initSlider() {
			if (this.slider) return;

			const rootDiv = this.$refs["root-div"];
			const slider = new MobileSlider(this.srcObjectsArray, rootDiv);
			slider.init();
			this.slider = slider
		},
	},
	mounted() {
		if (this.screenType !== "desktop") {
			this.initSlider();
		}
	},
	watch: {
		screenType: function (newVal, oldVal) {
			if (newVal !== "desktop") {
				this.initSlider();
			} else {
				this.slider = null;
				this.$refs["root-div"].innerHTML = "";
			}
		},
	},
};
</script>

<style></style>
